import type { ComponentProps } from 'react';

import { cn } from '@crm/shared/lib/styles/utils';

type EditableFieldProps = Omit<ComponentProps<'input'>, 'defaultValue' | 'value'> & {
    value: string | number | null;
};

export const EditableField = ({
    value,
    className,
    onFocus,
    onMouseLeave,
    ...props
}: EditableFieldProps) => (
    <input
        defaultValue={value ?? ''}
        placeholder="-"
        className={cn(
            '-my-1.5 h-7 w-full min-w-0 rounded-lg border border-transparent bg-transparent px-2 py-1 text-xs leading-4 font-normal text-smtr-main-black-100 transition-colors outline-none',
            'placeholder:text-smtr-main-tertiary-100 hover:border-gray-200 hover:bg-white focus:border-gray-200 focus:bg-white focus:shadow-sm aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 data-[suppress-hover=true]:hover:border-transparent',
            className
        )}
        onFocus={(event) => {
            delete event.currentTarget.dataset.suppressHover;
            onFocus?.(event);
        }}
        onMouseLeave={(event) => {
            delete event.currentTarget.dataset.suppressHover;
            onMouseLeave?.(event);
        }}
        {...props}
    />
);
